import {CreatePlant} from "@/api/plant";

const state = () => ({
    plants: [],
    total: 0,
})

// getters
const getters = {}

const actions = {
    async CreatePlant({dispatch}, params) {
        await dispatch("loading/setLoading", true, {root: true})
        CreatePlant(params).then((data) => {
            console.log("createPlant, data=", data)
        }).catch((err) => {
            console.log(err)
        }).finally(async () => {
            await dispatch("loading/setLoading", false, {root: true})
        })
    },
}

// mutations
const mutations = {
    setZones (state, plants) {
        console.log("plant= ", plants)
        state.plants = plants
    },
    setTotal (state, total) {
        state.total = total
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
